export const MILLISECONDS_PER_SECOND = 1_000;
export const MILLISECONDS_PER_DAY = MILLISECONDS_PER_SECOND * 60 * 60 * 24;
export const ISO_DATE_TIME_SEPARATOR = "T" as const;
